module.exports = __webpack_public_path__ + "img/android-chrome-192x192.8e6c3dfe.png";